export default
{
	fieldEmCheck:
	{
		settings:
		{
			checked_status_in_db: 'Активность в БД',
			unchecked_status_in_db: 'Неактивность в БД',
			enter_checked_string: 'Введите обозначение активности',
			enter_unchecked_string: 'Введите обозначение неактивности',
		}
	},
	fieldEmDate:
	{
		settings:
		{
			include_time: 'Указывать время',
		}
	},
	fieldEmFile:
	{
		settings:
		{
			folder_for_save: 'Папка для сохранения',
			resolutions: 'Разрешения',
			width: 'Ширина',
			height: 'Высота',
			add_resolution: 'Добавить разрешение',
		},
		no_files: 'Нет файлов',
		add_file: 'Добавить файл',
		choose_file: 'Выбрать файл',
		embed_link: 'Использовать ссылку',
	},
	fieldEmList:
	{
		settings:
		{
			key: 'Ключ',
			value: 'Значение',
			add_option: 'Добавить опцию',
			enter_key: 'Введите ключ',
			enter_value: 'Введите значение',
		}
	},
	fieldEmNode:
	{
		settings:
		{
			node_field: 'Связующее поле',
			search_field: 'Искомое поле',
			select_field: 'Выберите поле',
			select_table: 'Выберите таблицу'
		}
	},
	fieldEmMatrix:
	{
		settings:
		{
			key_field: 'Связующее поле',
			select_field: 'Выберите поле',
			select_table: 'Выберите таблицу',
			node_table: 'Таблица связей',
			many_to_many: 'Многие ко многим',
		},
	},
	fieldEmInteger:
	{
		settings:
		{
			min_max: 'Минимум должен быть меньше максимума',
		},
		min_max_error: 'Некорректное значение. Минимум: {min}, максимум: {max}',
	},
	forms:
	{
		list:
		{
			search_for_an_option: 'Поиск опций...',
		},
		loader:
		{
			loading: 'Загрузка...'
		}
	},
	pagination:
	{
		elements_per_page: 'Элементов на странице - ',
	},
	settingsLang:
	{
		select_language: 'Выберите язык:',
	},
	settingsTable:
	{
		no_tables: 'Таблиц нет',
	},
	sidebar:
	{
		extensions: 'Расширения',
		settings_and_users: 'Настройки и пользователи',
	},
	tviews:
	{
		empty_table: 'Пустая таблица',
	},
	pages:
	{
		settings:
		{
			user_and_table_settings: 'Настройки пользователей и таблиц',
		},
		update:
		{
			check_and_update_element: 'Проверить и обновить element',
			current_version: 'Текущая версия:',
			you_have_the_latest_version: 'У вас установлена последняя версия',
			system_has_been_updated_successfully: 'Система была успешно обновлена',
			check_version: 'Проверить версию',
			update_to: 'Обновить до',
		},
		table:
		{
			edit_element: 'Редактирование элемента',
			new_element: 'Новый элемент',
		}
	},
	auth:
	{
		forgot_your_password: 'Забыли пароль?',
		log_in: 'Войти',
		forgot_password: 'Восстановление пароля',
		reset_password: 'Удалить пароль',
		return_to_log_in_page: 'Вернуться к странице авторизации?',
		new_password_was_sended_to_your_email: 'New password was sended to your email.',
		enter_your_login_or_email: 'Введите ваш логин или Email',
		enter_your_password: 'Введите ваш пароль',
		enter_your_email: 'Введите ваш Email',
		incorrect_login: 'Неверный логин',
		incorrect_password: 'Неверный пароль',
		incorrect_email: 'Некорректный Email',
		incorrect_login_or_password: 'Неверный логин или пароль',
		empty_email: 'Пустой Email',
		invalid_email_format: 'Неправильный формат Email',
	},
	popups:
	{
		filtersPopup:
		{
			add_filter: 'Добавить фильтр',
		},
		sortPopup:
		{
			add_sort: 'Добавить сортировку',
			asc: 'По возрастанию',
			desc: 'По убыванию',
		},
		confirmCloseButtons:{
			close:'Вы уверены, что хотите закрыть редактор?',
			confirm_close: 'Закрыть',
			cancel: 'Не закрывать'
		},
		confirmDeletePopup:
		{
			remove: 'Вы уверены, что хотите удалить этот элемент навсегда?',
			removeSelected: 'Вы уверены, что хотите удалить эти элементы навсегда?',
			confirm_delete: 'Да, Удалить',
			cancel: 'Отменить',
		},
		addUser:
		{
			this_field_required: 'Это поле обязательное'
		}
	},
	yes: 'Да',
	no: 'Нет',
	remove: 'Удалить',
	delete: 'Удалить',
	edit: 'Редактировать',
	duplicate: 'Дублировать',
	upload: 'Загрузить',
	upload_by_link: 'Загрузить по ссылке',
	select_an_option: 'Выберите вариант',
	value: 'Значение',
	empty: 'Пусто',
	table: 'Таблица',
	tables: 'Таблицы',
	languages: 'Языки',
	groups: 'Группы',
	users: 'Пользователи',
	developed_by: 'Разработано',
	cancel: 'Отмена',
	save_settings: 'Сохранить настройки',
	clear: 'Очистить',
	paste_link: 'Вставить ссылку',
	code: 'Код',
	name: 'Наименование',
	name2: 'Название',
	show: 'Отображать ',
	settings: 'Настройки',
	settings_of: 'Настройки {of_what}',
	login: 'Логин',
	set_something: 'Задать ',
	password: 'Пароль',
	update: 'Обновить',
	log_out: 'выйти',
	save: 'Сохранить',
	create: 'Создать',
	properties: 'Свойства',
	sort: 'Сортировка',
	filter: 'Фильтр',
	add_element: 'Добавить элемент',
	add_user: 'Добавить пользователя',
	add: 'Добавить',
	enter_something: 'Введите ',
	key: 'Ключ',
	createGroup: 'Создать группу',
	addGroup: 'Добавить группу',
	disableAccess: 'Отключить доступ',
	members: 'участники: {count}',
	addMember: 'Добавить пользователя',
	accessDenied: 'Доступ запрещен',
	search: 'Поиск',
	max: 'Максимум',
	min: 'Минимум',
	open: 'Открыть',
	months:
	[
		'Январь',
		'Февраль',
		'Март',
		'Апрель',
		'Май',
		'Июнь',
		'Июль',
		'Август',
		'Сентябрь',
		'Октябрь',
		'Ноябрь',
		'Декабрь'
	],
	elMessages:
	{
		password_saved: 'Пароль сохранен.',
		user_saved: 'Пользователь сохранен.',
		settings_saved: '😎 Настройки сохранены!',
		something_goes_wrong: 'Что-то пошло не так!',
		element_saved: '👌 Элемент сохранен!',
		element_created: 'Элемент создан!',
		element_removed: 'Элемент удален!',
		cant_create_element: 'Не удалось создать элемент!',
	},
};
